import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';
import HeaderSecondary from '@components/HeaderSecondary';
import { HealthQuotePremiumCardBody } from '@components/Feature/HealthQuote';

import { paymentTransactionCreate, PaymentTransactionCreatePayload } from './action';
import { useHealthQuoteFetch, useBillingFetch } from './hook';
import { selectHealthQuotePaymentPage } from './selector';
import HealthQuotePaymentForm, { FormValues } from '@components/HealthQuotePaymentForm';

const HealthQuotePaymentPage = () => {
  const dispatch = useDispatch();
  const healthQuote = useHealthQuoteFetch();
  const billing = useBillingFetch();
  const { paymentTransaction } = useSelector(selectHealthQuotePaymentPage);

  if (isUndefined(healthQuote) || isUndefined(billing)) return <Loading />;
  if (isNull(healthQuote) || isNull(billing)) return <LoadingError />;

  const { healthPlanName } = healthQuote;
  const { chargeAmount, chargeAmountKhr } = billing;

  const handleSubmit = (values: FormValues) => {
    const payload: PaymentTransactionCreatePayload = { billingId: billing.id, ...values };
    dispatch(paymentTransactionCreate(payload));
  };

  return (
    <>
      <HeaderSecondary />
      <Container className="my-3">
        <Row>
          <Col lg={8} className="mx-auto">
            <Card>
              <HealthQuotePremiumCardBody
                {...healthQuote}
                totalPremium={chargeAmount}
                totalPremiumKhr={chargeAmountKhr}
                planName={healthPlanName} />

              <Card.Body>
                <HealthQuotePaymentForm onSubmit={handleSubmit} paymentTransaction={paymentTransaction} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { HealthQuotePaymentPage };
